import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Divider,
  Link,
  Container,
  Card,
  CardContent,
  Box,
  Typography,
} from '@mui/material';
import Login from './login/LoginFirebase';
import Signup from './register/RegisterFirebase';

const AuthEmbed = ({
  className,
  onSuccess,
  onError,
  show,
  trainerId,
  ...rest
}) => {
  const [showSignup, setShowSignup] = useState(show === 'signup');
  const [showLogin, setShowLogin] = useState(show === 'login');

  return (
    <Box sx={{ padding: 2 }} {...rest}>
      <Box sx={{ maxWidth: 600 }} mb={8}>
        <Card>
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 4,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                mt: 3,
              }}
            >
              {showSignup && (
                <Signup
                  trainerId={trainerId}
                  onSuccess={onSuccess}
                  onError={onError}
                  onLoginClick={() => {
                    setShowLogin(true);
                    setShowSignup(false);
                  }}
                />
              )}
              {showLogin && (
                <Login
                  trainerId={trainerId}
                  onSuccess={onSuccess}
                  onError={onError}
                  onSignupClick={() => {
                    setShowLogin(false);
                    setShowSignup(true);
                  }}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

AuthEmbed.propTypes = {
  className: PropTypes.string,
  trainerId: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

AuthEmbed.defaultProps = {
  onSuccess: () => {},
  onError: () => {},
};

export default AuthEmbed;
